/* eslint-disable react-native/no-inline-styles */
import {Button, Card, Layout, Modal, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View} from 'react-native';
import {useSelector} from 'react-redux';
import {isLandscape as isLandscapeUtil, px, wp} from '../../../../utils';
import {TitleRow} from '../../../components';
import {useNavigation} from '@react-navigation/core';

import {DRAWER_ROUTES} from '../../../../navigation/constants';

const ChangeGradeModal = ({kidId, packageData, onClose, onNextPressed}) => {
  const navigation = useNavigation();
  const user = useSelector((state) => state.auth.user);

  var canProceed = true;
  if (!user?.momContact || !user?.dadContact) {
    canProceed = false;
  }
  const gotoSetting = () => {
    onClose();
    navigation.navigate(DRAWER_ROUTES.settings.path);
  };

  const handleNext = () => {
    const paramsToSet = {data: {...packageData}};
    onNextPressed(paramsToSet);
    onClose();
  };

  return (
    <Modal
      visible={Boolean(packageData)}
      backdropStyle={styles.backdrop}
      onBackdropPress={() => onClose()}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <TitleRow
            title={canProceed ? 'Confirm Student Level' : 'Alert'}
            type="primary"
            iconName="close-circle-outline"
            onIconClick={() => onClose()}
            containerStyle={styles.title}
          />
          {canProceed ? (
            <Text style={styles.primaryText}>
              {`You are paying for ${user?.gradeName || ''}`}
            </Text>
          ) : (
            <Text style={styles.primaryText}>
              {'Please enter your mom & dad contact number'}
            </Text>
          )}

          <View style={{flexDirection: 'row'}}>
            {canProceed ? (
              <>
                <View style={{flex: 1}}>
                  <Button
                    onPress={gotoSetting}
                    appearance="outline"
                    style={styles.submitButton}>
                    {'Change Grade'}
                  </Button>
                </View>
                <View style={{flex: 1}}>
                  <Button onPress={handleNext} style={styles.submitButton}>
                    {'Confirm'}
                  </Button>
                </View>
              </>
            ) : (
              <View style={{flex: 1}}>
                <Button
                  onPress={gotoSetting}
                  appearance="outline"
                  style={styles.submitButton}>
                  {'Continue'}
                </Button>
              </View>
            )}
          </View>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    width: isLandscapeUtil() ? wp(30) : wp(90),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  title: {
    width: '100%',
  },
  primaryText: {
    fontWeight: '600',
    fontSize: 16,
    textAlign: 'center',
    marginTop: px(50),
    marginBottom: px(50),
  },
  text: {
    fontWeight: '400',
    textAlign: 'center',
    marginHorizontal: px(17),
    marginBottom: px(17),
  },
  input: {
    marginHorizontal: px(17),
    marginBottom: px(17),
  },
  submitButton: {
    marginHorizontal: px(5),
    marginTop: px(26),
    marginBottom: px(17),
  },
  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    margin: px(17),
    marginTop: px(28),
  },
  infoText: {
    marginHorizontal: px(10),
    paddingVertical: px(10),
    textAlign: 'center',
    marginTop: px(16),
  },
  errorText: {
    marginHorizontal: px(17),
    borderColor: 'red',
    borderRadius: 8,
    borderWidth: 1,
    borderStyle: 'solid',
    paddingHorizontal: px(15),
    paddingVertical: px(10),
    textAlign: 'center',
    marginBottom: px(40),
  },
});

export default ChangeGradeModal;
